import { IChatThreadSummary, IChatThreadMessages } from '../domains/Chat';
import { api } from './api';

class ChatService {
  private apiService = api;

  public async getGymThreads() {
    return this.apiService.get<IChatThreadSummary[]>('chat/gym');
  }

  public async getGymThreadMessages(student_user_id: string) {
    return this.apiService.get<IChatThreadMessages>(
      `chat/gym/${student_user_id}`,
    );
  }

  public async sendGymMessage(student_user_id: string, body: string) {
    return this.apiService.post(`chat/gym/${student_user_id}/messages`, {
      body,
    });
  }

  public async closeThread(student_user_id: string) {
    return this.apiService.patch(`chat/gym/${student_user_id}/close`);
  }
}

export { ChatService };
